/* B.LÊM · Rebrand — página inicial */
(() => {
  const root = document.querySelector('[data-rb]');
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  root.classList.add('is-js');

  /* Título: cada palavra sobe de dentro de uma máscara */
  const h = root.querySelector('[data-split]');
  if (h) {
    const words = h.textContent.trim().split(/\s+/);
    h.setAttribute('aria-label', h.textContent.trim());
    h.innerHTML = words.map((w, i) => {
      const last = i === words.length - 1;
      return '<span class="w" aria-hidden="true"><span style="--i:' + i + '"' + (last ? ' class="it"' : '') + '>' + w + '</span></span>';
    }).join(' ');
  }
  requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-in-hero')));
  setTimeout(() => root.classList.add('is-in-hero'), 400);

  /* Revelar ao entrar no ecrã, uma só vez */
  const show = el => el.classList.add('is-in');
  const targets = root.querySelectorAll('[data-rv], [data-rail]');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(t => io.observe(t));
    setTimeout(() => targets.forEach(show), 6000);
  } else targets.forEach(show);

  /* Manifesto: as palavras acendem à medida que se lê */
  const man = root.querySelector('[data-words]');
  let mws = [];
  if (man) {
    const ws = man.textContent.trim().split(/\s+/);
    man.innerHTML = ws.map(w => '<span class="mw">' + w + '</span>').join(' ');
    mws = [...man.querySelectorAll('.mw')];
    if (reduce) mws.forEach(m => m.classList.add('on'));
  }

  /* Faixa da coleção: arrastar com o rato, setas e barra de progresso */
  const rail = root.querySelector('[data-rail]');
  const bar = root.querySelector('[data-rail-bar]');
  const prev = root.querySelector('[data-rail-prev]'), next = root.querySelector('[data-rail-next]');
  const railUpdate = () => {
    if (!rail) return;
    const max = rail.scrollWidth - rail.clientWidth;
    const p = max > 0 ? rail.scrollLeft / max : 1;
    if (bar) bar.style.setProperty('--p', Math.max(0.08, Math.min(1, rail.clientWidth / rail.scrollWidth + p * (1 - rail.clientWidth / rail.scrollWidth))).toFixed(3));
    if (prev) prev.disabled = rail.scrollLeft < 4;
    if (next) next.disabled = rail.scrollLeft > max - 4;
  };
  if (rail) {
    const step = () => { const c = rail.querySelector('.rb-card'); return c ? c.getBoundingClientRect().width + 20 : 320; };
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }));
    rail.addEventListener('scroll', railUpdate, { passive: true });
    railUpdate();
    /* arrastar com o rato (no toque, o browser já desliza nativamente) */
    let d = null, moved = false;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button !== 0) return; d = { x: e.clientX, s: rail.scrollLeft, t: e.timeStamp, v: 0, lx: e.clientX }; moved = false; });
    window.addEventListener('pointermove', e => {
      if (!d) return;
      const dx = e.clientX - d.x;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) { moved = true; rail.classList.add('is-drag'); }
      const dt = Math.max(1, e.timeStamp - d.t); d.v = (e.clientX - d.lx) / dt; d.lx = e.clientX; d.t = e.timeStamp;
      rail.scrollLeft = d.s - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!d) return;
      const v = d.v; d = null;
      if (!moved) return;
      rail.classList.remove('is-drag');
      if (!reduce && Math.abs(v) > 0.2) rail.scrollBy({ left: -v * 320, behavior: 'smooth' });
      setTimeout(() => { moved = false; }, 0);
    });
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* Cartões que inclinam com o cursor */
  if (fine && !reduce) root.querySelectorAll('[data-tilt]').forEach(c => {
    c.addEventListener('pointermove', e => {
      const r = c.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      c.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
    });
    c.addEventListener('pointerleave', () => { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
  });

  /* Abertura: azulejos e medalhão seguem o cursor com profundidades diferentes */
  const art = root.querySelector('[data-par]');
  if (art && fine && !reduce) {
    const tiles = art.querySelector('.rb-tiles'), medal = art.querySelector('.rb-hero__medal');
    art.closest('.rb-hero').addEventListener('pointermove', e => {
      const r = art.getBoundingClientRect();
      const x = (e.clientX - (r.left + r.width / 2)) / r.width, y = (e.clientY - (r.top + r.height / 2)) / r.height;
      tiles.style.setProperty('--px', (-x * 14).toFixed(1) + 'px'); tiles.style.setProperty('--py', (-y * 14).toFixed(1) + 'px');
      medal.style.setProperty('--mx', (x * 22).toFixed(1) + 'px'); medal.style.setProperty('--my', (y * 22).toFixed(1) + 'px');
    });
  }

  /* Tamanhos */
  const sz = root.querySelector('[data-sizes]');
  if (sz) {
    const tabs = [...sz.querySelectorAll('[data-sz]')], bs = [...sz.querySelectorAll('[data-szb]')];
    const pick = s => {
      tabs.forEach(t => { const on = t.dataset.sz === s; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      bs.forEach(b => b.classList.toggle('is-on', b.dataset.szb === s));
    };
    tabs.forEach(t => t.addEventListener('click', () => pick(t.dataset.sz)));
  }

  /* Lugares: no toque, o azulejo vira e desvira */
  root.querySelectorAll('.rb-place').forEach(p => {
    const flip = () => p.classList.toggle('is-flip');
    p.addEventListener('click', () => { if (!fine) flip(); });
    p.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
  });

  /* Scroll: manifesto palavra a palavra (funciona com o contentor de scroll do tema) */
  let ticking = false;
  const onScroll = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      if (mws.length && !reduce) {
        const r = man.getBoundingClientRect(), vh = innerHeight;
        const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        const k = Math.round(p * mws.length);
        mws.forEach((m, i) => m.classList.toggle('on', i < k));
      }
    });
  };
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  addEventListener('resize', () => { onScroll(); railUpdate(); });
  onScroll();
})();
